<template>
<div class="tabs-wrapper vuetify-font">
    <div class="tab-item" :class="{'tab-item-selected': tab_item_selected == tab.id}"
     v-for="tab of tab_items" @click="emit('switch-tab', tab.id)">{{tab.name.toUpperCase()}}</div>
</div>
</template>

<script setup lang="js">

const emit = defineEmits(['switch-tab'])

const props = defineProps({
    tab_items: Object,
    tab_item_selected: String,
})

</script>

<style scoped>

.tabs-wrapper {
    width: max-content;
    margin: auto;
    color: var(--darkest);
    display: grid;
    grid-auto-flow: column dense;
    margin-bottom: 20px;
}

.tab-item {
    padding: 8px 16px;
    min-width: 60px;
}

.tab-item:hover {
    cursor: pointer;
    background-color: var(--lighter-grey);
}

.tab-item-selected {
    color: var(--default-blue);
    border-bottom: var(--default-blue) solid 2px;
}

.tab-item-selected:hover {
    cursor: default;
    background-color: inherit;
}

</style>